export interface MarketReportNotification {
    notification_id: string;
    monitor_id: string;
    monitor_name: string;
    analysis_version: string;
    created_at: string;
}
export interface MarketReportNotifications {
    workspace_id: string;
    items: MarketReportNotification[];
    next_cursor: string | null;
}
const object = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);
const uuid = (value: unknown): value is string => typeof value === 'string' && /^[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}$/i.test(value);
const timestamp = (value: unknown): value is string => typeof value === 'string' && value.length <= 40 && value.includes('T') && Number.isFinite(Date.parse(value));
export function validateReportNotifications(value: unknown, workspace: string, cursor: string | null): MarketReportNotifications {
    if (!object(value) || value.workspace_id !== workspace || !Array.isArray(value.items) || value.items.length > 20
        || !value.items.every(item => object(item) && Object.keys(item).length === 5 && uuid(item.notification_id)
            && uuid(item.monitor_id) && uuid(item.analysis_version) && typeof item.monitor_name === 'string'
            && item.monitor_name.trim().length > 0 && item.monitor_name.length <= 500 && timestamp(item.created_at))
        || new Set(value.items.map(item => item.notification_id)).size !== value.items.length)
        throw new Error('Invalid report notification response');
    if (value.next_cursor !== null) {
        if (typeof value.next_cursor !== 'string' || value.next_cursor.length > 100 || value.next_cursor === cursor)
            throw new Error('Invalid report notification cursor');
        const parts = value.next_cursor.split('|');
        if (parts.length !== 2 || !timestamp(parts[0]) || !uuid(parts[1])) throw new Error('Invalid report notification cursor');
    }
    return value as unknown as MarketReportNotifications;
}
